import axios from 'axios';

const base = () => `${window.store.event_backend_api}/communications/drafts`;

// Saved but unsent messages, scoped server-side to whoever is asking — see
// DraftController. Nothing here is queued for delivery; sendAdHocMessage is
// still the only call that reaches a policyholder.
export const listDrafts = () => axios.get(base()).then(({ data }) => data.data);

export const createDraft = (payload) => axios.post(base(), payload).then(({ data }) => data.data);

export const updateDraft = (id, payload) => axios.put(`${base()}/${id}`, payload).then(({ data }) => data.data);

export const deleteDraft = (id) => axios.delete(`${base()}/${id}`).then(({ data }) => data.data);
